module.exports = __webpack_public_path__ + "static/media/instruction_kk.4f56d86e.pdf";